import LogEntryStatus from './LogEntryStatus';
import { LogEntryStatusProps, LogEntryStatusValueProps } from './types';

export type { LogEntryStatusProps, LogEntryStatusValueProps };
export default LogEntryStatus;
